import { render } from "./VSearchField.vue?vue&type=template&id=67ddcb85&ts=true"
import script from "./VSearchField.vue?vue&type=script&lang=ts"
export * from "./VSearchField.vue?vue&type=script&lang=ts"

import "./VSearchField.vue?vue&type=style&index=0&id=67ddcb85&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__